import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postVoucherType } from '../../../../actions';
import { VOUCHER_TYPE_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import VoucherTypeForm from './VoucherTypeForm';

const NewVoucherType = ({ breadcrumbs, dispatchpostVoucherType }) => {
  const onSubmit = (formValues) =>
    dispatchpostVoucherType({
      ...formValues,
    });

  const content = <VoucherTypeForm onSubmit={onSubmit} />;
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Tipo de Comprobante"
      subtitle="Crear una nuevo tipo de comprobante."
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchpostVoucherType: postVoucherType,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Comprobantes',
      href: VOUCHER_TYPE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

NewVoucherType.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchpostVoucherType: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewVoucherType);
